import { Offer } from '@/types/config'

export const isForm = (offer: Offer) => {
  if (!offer) return false
  return offer.triggeredAction?.type !== 'link'
}

export const offerLink = (offer: Offer) => {
  const isCta = !isForm(offer);
  return {
    name: isCta ? ROUTES.OFFER : ROUTES.FORM,
    params: {
      offerId: offer.id
    }
  }
}

export const offerUsedBy = (offer: Offer) => {
  const flowStore = useFlowStore()
  return flowStore.flows.filter((flow) => {
    let found = false
    funnelDefinitionEach(flow.funnelDefinition, (node) => {
      if (node.type === 'offer' && node.offerId === offer.id) {
        found = true
      }
    })
    return found
  })
}

export const offerIsInUse = (offer: Offer) => {
  return offerUsedBy(offer).length > 0
}

export const offerCanBeSubmitted = (offer: Offer) => {
  if (offer.triggeredAction?.type === 'link') return true
  if (offer.triggeredAction.type === 'form')
    return offer.triggeredAction.settings.formIds?.length > 0
  if (offer.triggeredAction.type === 'list')
    return offer.triggeredAction.settings.listIds?.length > 0
  if (offer.triggeredAction.type === 'tag')
    return offer.triggeredAction.settings.tagIds?.length > 0
  if (offer.triggeredAction.type === 'event')
    return offer.triggeredAction.settings.eventIds?.length > 0
  return false
}
